interface CreateContactRepMessagePayload {
  product_id: number;
  project_id: number;
  manufacturer: string;
  rep_id: string;
  product_name: string;
  message_source: string; // "Quick view" | "Request quote" | ...
  message_type: 'quote';
  quote: {
    sizing?: string;
    interior?: string;
    exterior?: string;
    grilles?: string;
    glass?: string;
    hardware?: string;
    trim?: string;
    colorway?: string;
    purchasing_qty: string;
    unit_of_measure: string;
  };
}

/**
 * Creates an inbox message to contact a representative.
 *
 * @param payload An object conforming to the `CreateContactRepMessagePayload` type, containing the message details.
 * @returns A promise that resolves to the response data if the message creation is successful.
 * @throws An error if the fetch request fails, the response is not OK, or an unexpected error occurs.
 */
export const createContactRepMessage = async (
  payload: CreateContactRepMessagePayload,
) => {
  try {
    const response = await fetch('/rest/V1/mit/contact-rep', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating order:', error.message);
    throw error;
  }
};
